<template lang="pug">
v-main
  v-container(fluid, fill-height)
    v-layout(align-center, justify-center)
      v-flex(text-center)
        div(style="padding: 3rem")
          v-icon(size="120", color="error") block
          h1.display-2.mt-4 403 - Access Forbidden
          p.headline.mt-3 You do not have permission to access this page.
          p.subheading.grey--text This feature is only available for users with Payment Voucher access.
          v-btn.mt-5(color="primary", large, @click="goHome") Go to Homepage
</template>

<script>
export default {
  name: "Forbidden",
  methods: {
    goHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.v-main {
  background: #f5f5f5;
}
</style>
